import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { ZodIssueCode } from 'zod';
import { ErrorMessagesHelper } from '../helpers/ErrorMessagesHelper.js';
import { Locales } from '../strings/Locales.js';
/* eslint-disable @helpers/no-nested-ternaries */ export var ErrorMessagesMap = function ErrorMessagesMap(issue, ctx) {
    var message = '';
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            var vowelRegex = new RegExp('^[aeiou].*', 'i');
            var startsWithVowel = issue.expected.match(vowelRegex);
            if (startsWithVowel) {
                message = Locales.format('ErrorMessages.input.requiredStartsWithVowel', {
                    expectedType: issue.expected
                });
            } else {
                message = Locales.format('ErrorMessages.input.required', {
                    expectedType: issue.expected
                });
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = Locales.format('ErrorMessages.input.invalidLiteral', {
                expectedLiteralValue: JSON.stringify(issue.expected, ErrorMessagesHelper.jsonBigIntReplacer)
            });
            break;
        case ZodIssueCode.invalid_string:
            if (_type_of(issue.validation) === 'object') {
                if ('startsWith' in issue.validation) {
                    message = Locales.format('ErrorMessages.string.startsWith', {
                        value: issue.validation.startsWith
                    });
                } else if ('endsWith' in issue.validation) {
                    message = Locales.format('ErrorMessages.string.endsWith', {
                        value: issue.validation.endsWith
                    });
                } else {
                    ErrorMessagesHelper.assertNever(issue.validation);
                }
            } else if (issue.validation === 'email') {
                message = Locales.format('ErrorMessages.string.invalidEmail');
            } else if (issue.validation === 'url') {
                message = Locales.format('ErrorMessages.string.invalidUrl');
            } else if (issue.validation === 'uuid') {
                message = Locales.format('ErrorMessages.string.invalidUuid');
            } else if (issue.validation === 'cuid') {
                message = Locales.format('ErrorMessages.string.invalidCuid');
            } else if (issue.validation === 'datetime') {
                message = Locales.format('ErrorMessages.string.invalidDatetime');
            } else if (issue.validation === 'regex') {
                message = Locales.format('ErrorMessages.string.invalidRegex');
            } else if (issue.validation === 'ip') {
                message = Locales.format('ErrorMessages.string.invalidIpAddress');
            } else if (issue.validation === 'cidr') {
                message = Locales.format('ErrorMessages.string.invalidCidrAddress');
            } else {
                message = Locales.format('ErrorMessages.input.invalid');
                ErrorMessagesHelper.assertNever(issue.validation);
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === 'string') {
                message = issue.exact ? Locales.format('ErrorMessages.string.exactly', {
                    smart_count: Number(issue.minimum)
                }) : issue.inclusive ? Locales.format('ErrorMessages.string.minInclusive', {
                    smart_count: Number(issue.minimum)
                }) : Locales.format('ErrorMessages.string.minExclusive', {
                    smart_count: Number(issue.minimum)
                });
            } else if (issue.type === 'number') {
                message = issue.exact ? Locales.format('ErrorMessages.number.exactly', {
                    exactNumber: issue.minimum
                }) : issue.inclusive ? Locales.format('ErrorMessages.number.minInclusive', {
                    minNumber: issue.minimum
                }) : Locales.format('ErrorMessages.number.minExclusive', {
                    minNumber: issue.minimum
                });
            } else if (issue.type === 'date') {
                message = issue.exact ? Locales.format('ErrorMessages.date.exactly', {
                    exactDate: new Date(Number(issue.minimum))
                }) : issue.inclusive ? Locales.format('ErrorMessages.date.minInclusive', {
                    minDate: new Date(Number(issue.minimum))
                }) : Locales.format('ErrorMessages.date.minExclusive', {
                    minDate: new Date(Number(issue.minimum))
                });
            } else if (issue.type === 'array') {
                message = issue.exact ? Locales.format('ErrorMessages.array.exactly', {
                    smart_count: Number(issue.minimum)
                }) : issue.inclusive ? Locales.format('ErrorMessages.array.minInclusive', {
                    smart_count: Number(issue.minimum)
                }) : Locales.format('ErrorMessages.array.minExclusive', {
                    smart_count: Number(issue.minimum)
                });
            } else {
                message = Locales.format('ErrorMessages.input.invalid');
            }
            break;
        case ZodIssueCode.too_big:
            if (issue.type === 'string') {
                message = issue.exact ? Locales.format('ErrorMessages.string.exactly', {
                    smart_count: Number(issue.maximum)
                }) : issue.inclusive ? Locales.format('ErrorMessages.string.maxInclusive', {
                    smart_count: Number(issue.maximum)
                }) : Locales.format('ErrorMessages.string.maxExclusive', {
                    smart_count: Number(issue.maximum)
                });
            } else if (issue.type === 'number') {
                message = issue.exact ? Locales.format('ErrorMessages.number.exactly', {
                    exactNumber: issue.maximum
                }) : issue.inclusive ? Locales.format('ErrorMessages.number.maxInclusive', {
                    maxNumber: issue.maximum
                }) : Locales.format('ErrorMessages.number.maxExclusive', {
                    maxNumber: issue.maximum
                });
            } else if (issue.type === 'date') {
                message = issue.exact ? Locales.format('ErrorMessages.date.exactly', {
                    exactDate: new Date(Number(issue.maximum))
                }) : issue.inclusive ? Locales.format('ErrorMessages.date.maxInclusive', {
                    maxDate: new Date(Number(issue.maximum))
                }) : Locales.format('ErrorMessages.date.maxExclusive', {
                    maxDate: new Date(Number(issue.maximum))
                });
            } else if (issue.type === 'array') {
                message = issue.exact ? Locales.format('ErrorMessages.array.exactly', {
                    exactElements: issue.maximum
                }) : issue.inclusive ? Locales.format('ErrorMessages.array.maxInclusive', {
                    smart_count: Number(issue.maximum)
                }) : Locales.format('ErrorMessages.array.maxExclusive', {
                    smart_count: Number(issue.maximum)
                });
            } else {
                message = Locales.format('ErrorMessages.input.invalid');
            }
            break;
        case ZodIssueCode.invalid_date:
            message = Locales.format('ErrorMessages.date.invalid');
            break;
        case ZodIssueCode.not_multiple_of:
            message = Locales.format('ErrorMessages.number.notMultipleOf', {
                expectedMultipleOf: issue.multipleOf
            });
            break;
        case ZodIssueCode.not_finite:
            message = Locales.format('ErrorMessages.number.notFinite');
            break;
        case ZodIssueCode.invalid_enum_value:
            message = Locales.format('ErrorMessages.enum.invalidEnumValue', {
                expectedEnumValues: ErrorMessagesHelper.joinValues(issue.options)
            });
            break;
        case ZodIssueCode.invalid_union:
            message = Locales.format('ErrorMessages.input.invalid');
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = Locales.format('ErrorMessages.union.invalidUnionDiscriminator', {
                expectedDiscriminatorValues: ErrorMessagesHelper.joinValues(issue.options)
            });
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = Locales.format('ErrorMessages.intersection.invalidType');
            break;
        case ZodIssueCode.unrecognized_keys:
            message = Locales.format('ErrorMessages.object.unrecognizedKeys', {
                objectKeys: ErrorMessagesHelper.joinValues(issue.keys, ', ')
            });
            break;
        case ZodIssueCode.invalid_arguments:
            message = Locales.format('ErrorMessages.functionSchema.invalidArguments');
            break;
        case ZodIssueCode.invalid_return_type:
            message = Locales.format('ErrorMessages.functionSchema.invalidReturnType');
            break;
        case ZodIssueCode.custom:
            message = Locales.format('ErrorMessages.input.invalid');
            break;
        default:
            message = ctx.defaultError;
            ErrorMessagesHelper.assertNever(issue);
    }
    return {
        message: message
    };
};

//# sourceMappingURL=ErrorMessagesMap.js.map